module.exports = __webpack_public_path__ + "img/電気回路_2_6_2.438a143d.png";